import { Flex } from "@mantine/core";
import AboutHeroSection from "./components/AboutHeroSection";
import WhoWeAreSection from "./components/WhoWeAreSection";
import WhyGTConnectSection from "./components/WhyGTConnectSection";
import VerificationSection from "./components/VerificationSection";
import SecuritySection from "./components/SecuritySection";
import CTASection from "../../components/shared/CTASection";

export default function AboutUs() {
  return (
    <Flex direction="column" bg="white">
      <AboutHeroSection />
      <WhoWeAreSection />
      <WhyGTConnectSection />
      <VerificationSection />
      <SecuritySection />
      <CTASection
        title="Join Our Network"
        subtitle="Join verified businesses worldwide and start building secure partnerships today"
        buttons={[
          {
            text: "Explore Companies",
            link: "/discover",
            style: "primary",
            showIcon: true,
          },
          {
            text: "Register Your Company",
            link: "/signup",
            style: "secondary",
          },
        ]}
      />
    </Flex>
  );
}
